import { FC, ReactElement } from 'react';
import { Icons } from '~/assets/fonts/Icons/icons';
import theme from '~/constants/styles';
import { historyPushWithSaveBackPath } from '~/helpers';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import Icon from '~/view/components/Controls/Icon/Icon';
import './style.scss';

interface IProps {
  path: string;
  linkTitle: string;
  description: string;
}

const DashboardDetailsMarketingHelpBlock: FC<IProps> = ({ path, linkTitle, description }: IProps): ReactElement => {
  const onPush = () => {
    historyPushWithSaveBackPath(path);
  };

  return (
    <div className="d-flex flex-column gap-15">
      <Button onClick={onPush} appearance="secondary" stretched titleClassName="dashboard-details-marketing-help-block__btn">
        <>
          <Icon name={Icons.Link} size={20} color={theme.colors.mainblue} />
          <p className="dashboard-details-marketing-help-block__btn-title">{linkTitle}</p>
        </>
      </Button>

      <p className="dashboard-details-marketing-help-block__description letter-spacing-5">{description}</p>
    </div>
  );
};

export default DashboardDetailsMarketingHelpBlock;
